import React, { Component } from 'react'
import { connect } from 'react-redux'
import '../../App.css'
import './style.css'
import {
  Grid, TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  MenuItem,
  DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Pdf from "react-to-pdf";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import locale from 'antd/es/date-picker/locale/de_DE';
import moment from 'moment'
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import numeral from 'numeral';
import 'numeral/locales/de'
import { GetInvoices, EditInvoice, BuildInvoice, CreateNewInvoice, DeleteInvoice, FilterInvoices } from './ProjectsAction';
numeral.locale('de');

const dateFormat = 'DD.MM.YYYY';
const yearFormat = 'YYYY';
const monthFormat = 'MM';

const ref = React.createRef();
const options = {
  orientation: 'landscape',
};

const tableHeader = ['Aktion', 'Rech.-Nr.', "Datum", "Tage", "Honorare", "Nebenkosten", "Summe Netto", "Bemerkungen"]

class Invoices extends Component {

  constructor(props) {
    super(props);
    this.state = {
      propsProjectData: this.props.project_data,
      projectInvoices: this.props.project_invoices,
      processInvoiceDialog: false,
      deleteDialog: false,
      printActivityDialog: false,
      consultantList: this.props.consultant_list,
      vatRateField: this.props.system_settings.vatrate,
      invoiceNumber: '',
      totalfees: '',
      totalfeesSum: '',
      travelcosts: '',
      assistancecosts: '',
      administrationcost: '',
      totalnet: '',
      totalgross: '',
      comment: '',
      date: "",
      vatField: '',
      invoicePosition: [],
      editMode: false,
      monthField: '',
      yearField: '',
      dateTo: '',
      dateFrom: '',
      selectedFormat: '',
      exportData: false,
      invoiceId: '',
      error: '',
      contractData: ''
    }
    this.textInput = React.createRef();

  }
  focusTextInput = () => {
    this.textInput.current.focus();
  }

  componentDidMount = () => {
    const { propsProjectData } = this.state
    this.props.GetInvoices(propsProjectData.id)
  }




  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { project_invoices, build_invoice, error_validation, system_settings, filtered_invoices } = this.props
    if (nextProps.project_invoices !== project_invoices) {
      this.setState({
        projectInvoices: nextProps.project_invoices,
        processInvoiceDialog: false,
      })
      if (this.state.selectedFormat !== '') {
        this.setState({ exportData: true })
      }

    }
    // if (nextProps.filtered_invoices !== filtered_invoices) {
    //   if (this.state.selectedFormat !== '') {
    //     this.setState({ exportData: true })
    //   }
    // }
    if (nextProps.error_validation !== error_validation) {
      this.setState({ error: nextProps.error_validation })
    }
    if (nextProps.build_invoice !== build_invoice) {

      this.setState({
        invoicePosition: nextProps.build_invoice.invoice_positions,
        totalgross: "",
        invoiceNumber: '',
        vatField: '',
        totalfees: '',
        totalfeesSum: '',
        travelcosts: '',
        assistancecosts: '',
        administrationcost: '',
        totalnet: '',
        comment: '',
        date: new Date(),
        vatRateField: system_settings.vatrate,
        processInvoiceDialog: true
      })
      setTimeout(() => {
        this.focusTextInput()
      }, 100)
    }
  }

  renderTableHeader = () => {
    return tableHeader.map((val, index) => {
      return <TableCell align="center" key={index} width="45%">{val}</TableCell>
    })
  }

  getInvoiceData = (invoice) => {
    this.setState({
      invoiceId: invoice.id,
      invoiceNumber: invoice.invoiceno,
      vatField: Number(invoice.vat),
      totalfeesSum: Number(invoice.totalfees),
      travelcosts: Number(invoice.travelcosts),
      assistancecosts: Number(invoice.assistencecosts),
      administrationcost: Number(invoice.administrationcosts),
      totalnet: Number(invoice.totalnet),
      totalgross: Number(invoice.totalgross),
      vatRateField: Number(invoice.vatrate),
      comment: invoice.comment,
      date: invoice.date === null ? "" : moment(invoice.date).format("DD.MM.YYYY"),
      invoicePosition: invoice.invoice_positions,
      processInvoiceDialog: true,
      editMode: true
    })
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }


  getFormattedNumber(value) {
    return <NumberFormat
      customInput={TextField}
      value={value}
      className="rightToLeft showData"
      inputProps={{
        maxLength: 40
      }}
      thousandSeparator='.'
      decimalSeparator=","
      decimalScale='2'
      fixedDecimalScale={true}
    />
  }

  tableFields = (invoices) => {
    if (!isEmpty(invoices)) {
      return invoices.map((invoice, index) =>
        <TableRow key={index}>
          <TableCell>
            <div style={{ display: "flex" }}>
              <EditIcon onClick={() => this.getInvoiceData(invoice)} />
              <DeleteIcon onClick={() => this.setState({ deleteDialog: true, invoiceId: invoice.id })} />
            </div>
          </TableCell>
          <TableCell align="left">
            {invoice.invoiceno}
          </TableCell>
          <TableCell align="center">
            {invoice.date !== null ? moment(invoice.date).format("DD.MM.YYYY") : ''}
          </TableCell>
          <TableCell align="right">
            {this.getFormattedNumber(invoice.tage ? Number(invoice.tage) : '')}
          </TableCell>
          <TableCell align="right">
            {this.getFormattedNumber(invoice.totalfees ? Number(invoice.totalfees) : '')}
          </TableCell>
          <TableCell align="right">
            {this.getFormattedNumber(Number((Number(invoice.administrationcosts) + Number(invoice.assistencecosts) + Number(invoice.travelcosts)).toFixed(2)))}
          </TableCell>
          <TableCell align="right">
            {this.getFormattedNumber(invoice.totalnet ? Number(invoice.totalnet) : '')}
          </TableCell>
          <TableCell align="left">
            {invoice.comment}
          </TableCell>
        </TableRow>
      )
    }
  }



  daysHandleChange = (e, index, val) => {
    const { invoicePosition, travelcosts, assistancecosts, administrationcost, vatRateField } = this.state
    let dailyRate = invoicePosition[index].dailyrate !== null ? Number(invoicePosition[index].dailyrate) : 0
    if (val === "days") {
      invoicePosition[index].days = e.target.value !== '' ? numeral(e.target.value).value() : ""
      invoicePosition[index].totalfees = (invoicePosition[index].days * dailyRate).toFixed(2)
    }
    let allDays = []
    invoicePosition.forEach(data => {
      allDays.push(data.totalfees)
    })
    let sum = allDays.reduce((a, b) => Number(a) + Number(b))
    let totalnetSum = Number(sum) + Number(travelcosts) + Number(assistancecosts) + Number(administrationcost)
    let vat = Number(vatRateField) * Number(totalnetSum) / 100
    let gross = totalnetSum + Number(vat)
    this.setState({ invoicePosition, totalfeesSum: sum, totalnet: totalnetSum.toFixed(2), vatField: vat.toFixed(2), totalgross: gross.toFixed(2) })
  }

  createInvoice = () => {
    const dataObj = this.state
    this.props.CreateNewInvoice(dataObj)
  }
  editInvoice = () => {
    const dataObj = this.state
    this.props.EditInvoice(dataObj)
  }

  deleteInvoice = () => {
    const { propsProjectData, invoiceId } = this.state
    this.props.DeleteInvoice(propsProjectData.id, invoiceId)
    this.setState({ deleteDialog: false })
  }

  filteredInvoice = () => {
    const dataObj = this.state
    if (((dataObj.dateFrom && dataObj.dateTo) !== "") || ((dataObj.monthField && dataObj.yearField) !== ""))
      this.props.FilterInvoices(dataObj)
  }

  render() {
    const { propsProjectData, invoicePosition, processInvoiceDialog, invoiceNumber, date, comment,
      vatRateField,
      totalfeesSum,
      travelcosts,
      assistancecosts,
      administrationcost,
      totalnet,
      vatField,
      totalgross,
      editMode,
      deleteDialog,
      printActivityDialog,
      monthField,
      yearField,
      dateTo,
      dateFrom,
      selectedFormat,
      error,
      exportData,
      projectInvoices, contractData
    } = this.state
    const { forOther, forOwn, project_invoices_summary, filtered_invoices, isInactive } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    return (
      <div className={`${(Number(access_rights.projects_invoices_for_other) !== 2 && forOther) || (Number(access_rights.projects_invoices_for_own) !== 2 && forOwn) ?
        "disableALlFields" : ""}`}>
        <div className="capacityTable tableAction">
          <Grid container spacing={1}>
            {!((Number(access_rights.projects_invoices_for_other) !== 2 && forOther) || (Number(access_rights.projects_invoices_for_own) !== 2 && forOwn)) &&
              <div className="action-top-btn">
                <Button variant="outlined" color="primary" disabled={isInactive} onClick={() => {
                  this.props.BuildInvoice(propsProjectData.id)
                  this.setState({ editMode: false })
                }}>Rechnung hinzufügen</Button>
                <Button variant="outlined" color="primary" disabled={isInactive} onClick={() => this.setState({ printActivityDialog: true })}>Tätigkeitsnachweis drucken</Button>
              </div>
            }
            <TableContainer>
              <Table id="invoice_table" ref={ref}>
                <TableHead>
                  <TableRow>
                    {this.renderTableHeader()}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.tableFields(projectInvoices)}
                  {project_invoices_summary &&
                    <TableRow>
                      <TableCell allign="left" colSpan="3">
                        Summe
                    </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.tage ? Number(project_invoices_summary.tage) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                          fixedDecimalScale={true}
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.totalfees !== "" ? Number(project_invoices_summary.totalfees) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                          fixedDecimalScale={true}

                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={Number((Number(project_invoices_summary.administrationcosts) + Number(project_invoices_summary.assistencecosts) + Number(project_invoices_summary.travelcosts)).toFixed(2))}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                          fixedDecimalScale={true}

                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.totalnet ? Number(project_invoices_summary.totalnet) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                          fixedDecimalScale={true}

                        />
                      </TableCell>
                      <TableCell align="left">
                      </TableCell>
                    </TableRow>
                  }
                  {project_invoices_summary &&
                    <TableRow>
                      <TableCell allign="right" colSpan="6">
                        Diff. Vertrag / Rechnungen
                    </TableCell>
                      <TableCell align="right" >
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={Number(project_invoices_summary.diff_verch_rech)}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                          fixedDecimalScale={true}
                        />
                      </TableCell>
                    </TableRow>
                  }
                </TableBody>
              </Table>

              {/* <Table style={{ display: "none" }} id="invoice_table" ref={ref} >
                <TableHead>
                  <TableRow>
                    {this.renderTableHeader()}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.tableFields(filtered_invoices)}
                   {project_invoices_summary &&
                    <TableRow>
                      <TableCell allign="left" colSpan="3">
                        Summe
                    </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.tage ? Number(project_invoices_summary.tage) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.totalfees !== "" ? Number(project_invoices_summary.totalfees) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={Number((Number(project_invoices_summary.administrationcosts) + Number(project_invoices_summary.assistencecosts) + Number(project_invoices_summary.travelcosts)).toFixed(2))}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                        />
                      </TableCell>
                      <TableCell align="right">
                        <NumberFormat
                          customInput={TextField}
                          className="rightToLeft showData"
                          inputProps={{
                            maxLength: 40
                          }}
                          value={project_invoices_summary.totalnet ? Number(project_invoices_summary.totalnet) : ''}
                          thousandSeparator='.'
                          decimalSeparator=","
                          decimalScale='2'
                        />
                      </TableCell>
                      <TableCell align="left">
                      </TableCell>
                    </TableRow>
                  } 
                </TableBody>
              </Table>  */}


            </TableContainer>
          </Grid>

          <Dialog
            open={processInvoiceDialog}
            maxWidth="md"
            className="modal-new-in"
          >
            <DialogTitle>Rechnung hinzufügen / bearbeiten</DialogTitle>
            <DialogContent>
              <DialogContentText >

                <Grid container spacing={1}>
                  <Grid item xs={6} style={{ paddingTop: '30px' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}><div>Rechnung-Nr.</div></Grid>
                      <Grid item xs={9}>
                        <TextField fullWidth
                          value={invoiceNumber}
                          inputRef={this.textInput}
                          helperText={!isEmpty(error.invoiceno) ? error.invoiceno : ''} error={!isEmpty(error.invoiceno) ? true : false}
                          variant="outlined"
                          onChange={(e) => {
                            this.setState({ invoiceNumber: e.target.value })
                            if (!isEmpty(error.invoiceno))
                              error.invoiceno = []
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={3} style={{ paddingTop: '10px', fontSize: '14px' }}>Datum</Grid>
                      <Grid item xs={9}>
                        <DatePicker
                          locale={locale}
                          value={date === "" ? '' : moment(date, dateFormat)}
                          format={dateFormat}
                          placeholder="DD.MM.YYYY"
                          bordered={false}
                          onChange={(e) => {
                            if (e !== null) {
                              let newDate = moment(e).format("DD.MM.YYYY");
                              this.setState({ date: newDate })
                            } else {
                              this.setState({ date: '', })
                            }
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} style={{ paddingTop: '0px', fontSize: '14px' }}>Bemerkungen</Grid>
                      <Grid item xs={12} className="d-flex textarea-field textarea-field-2">
                        <TextField fullWidth multiline rows={5}
                          helperText={!isEmpty(error.comment) ? error.comment : ''} error={!isEmpty(error.comment) ? true : false}
                          value={comment}
                          variant="outlined"
                          onChange={(e) => {
                            this.setState({ comment: e.target.value })
                            if (!isEmpty(error.comment))
                              error.comment = []
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <div className="projectTable projectTable-n">
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell width="45%">Beraterfunktion</TableCell>
                          <TableCell align="center">Tage</TableCell>
                          <TableCell align="center">Tagessatz</TableCell>
                          <TableCell align="center">Honorare</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!isEmpty(invoicePosition) &&
                          invoicePosition.map((consultant, index) => (
                            <TableRow key={index}>
                              <TableCell width="45%">{consultant.consultant_function}</TableCell>
                              <TableCell align="center">
                                <NumberFormat
                                  customInput={TextField}
                                  className="rightToLeft"
                                  inputProps={{
                                    maxLength: 40
                                  }}
                                  variant="outlined"
                                  helperText={consultant.days !== null && consultant.days.toString().length > 8 && !isEmpty(error["invoice_positions.days"]) ? error["invoice_positions.days"] : ''}
                                  error={consultant.days !== null && consultant.days.toString().length > 8 && !isEmpty(error["invoice_positions.days"]) ? true : false}
                                  value={(consultant.days !== "" && consultant.days !== "0.0" && consultant.days !== null) ? Number(consultant.days) : ''}
                                  thousandSeparator='.'
                                  decimalSeparator=","
                                  decimalScale='2'
                                  onChange={(e) => {
                                    if (!isEmpty(error["invoice_positions.days"]))
                                      error["invoice_positions.days"] = ""
                                    this.daysHandleChange(e, index, "days")
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <NumberFormat
                                  customInput={TextField}
                                  className="rightToLeft"
                                  inputProps={{
                                    maxLength: 40
                                  }}
                                  variant="outlined"
                                  // helperText={consultant.totalfees !== null && consultant.totalfees.toString().length > 8 && !isEmpty(error.totalfees) ? error.totalfees : ''}
                                  // error={consultant.totalfees !== null && consultant.totalfees.toString().length > 8 && !isEmpty(error.totalfees) ? true : false}
                                  value={consultant.dailyrate !== "" ? Number(consultant.dailyrate) : ''}
                                  thousandSeparator='.'
                                  decimalSeparator=","
                                  fixedDecimalScale={true}
                                  decimalScale='2'
                                  disabled
                                />
                              </TableCell>
                              <TableCell align="center">
                                <NumberFormat
                                  customInput={TextField}
                                  className="rightToLeft"
                                  inputProps={{
                                    maxLength: 40
                                  }}
                                  variant="outlined"
                                  // helperText={consultant.totalfees !== null && consultant.totalfees.toString().length > 8 && !isEmpty(error.totalfees) ? error.totalfees : ''}
                                  // error={consultant.totalfees !== null && consultant.totalfees.toString().length > 8 && !isEmpty(error.totalfees) ? true : false}
                                  value={consultant.totalfees !== "" ? Number(consultant.totalfees) : ''}
                                  thousandSeparator='.'
                                  decimalSeparator=","
                                  fixedDecimalScale={true}
                                  decimalScale='2'
                                  disabled
                                />
                              </TableCell>
                            </TableRow>
                          ))
                        }


                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Summe Honorare</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              value={Number(totalfeesSum)}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              disabled
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Reisekosten</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              helperText={!isEmpty(error.travelcosts) ? error.travelcosts : ''} error={!isEmpty(error.travelcosts) ? true : false}
                              value={travelcosts !== "" ? Number(travelcosts) : ''}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              onChange={(e) => {
                                if (!isEmpty(error.travelcosts))
                                  error.travelcosts = []
                                let netTotal = numeral(e.target.value).value() + Number(administrationcost) + Number(assistancecosts) + Number(totalfeesSum);
                                let vat = Number(vatRateField) * Number(netTotal) / 100
                                let gross = Number(netTotal) + Number(vat)
                                this.setState({ travelcosts: e.target.value !== "" ? numeral(e.target.value).value() : '', totalnet: netTotal.toFixed(2), vatField: vat.toFixed(2), totalgross: gross.toFixed(2) })
                              }}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Assistenzkosten</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              helperText={!isEmpty(error.assistencecosts) ? error.assistencecosts : ''} error={!isEmpty(error.assistencecosts) ? true : false}
                              variant="outlined"
                              value={assistancecosts !== "" ? Number(assistancecosts) : ""}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              onChange={(e) => {
                                if (!isEmpty(error.assistencecosts))
                                  error.assistencecosts = []
                                let netTotal = numeral(e.target.value).value() + Number(administrationcost) + Number(travelcosts) + Number(totalfeesSum);
                                let vat = Number(vatRateField) * Number(netTotal) / 100
                                let gross = Number(netTotal) + Number(vat)
                                this.setState({ assistancecosts: e.target.value !== "" ? numeral(e.target.value).value() : '', totalnet: netTotal.toFixed(2), vatField: vat.toFixed(2), totalgross: gross })
                              }}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Verwaltungskosten</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              helperText={!isEmpty(error.administrationcosts) ? error.administrationcosts : ''} error={!isEmpty(error.administrationcosts) ? true : false}
                              value={administrationcost !== "" ? Number(administrationcost) : ''}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              onChange={(e) => {
                                if (!isEmpty(error.administrationcosts))
                                  error.administrationcosts = []
                                let netTotal = numeral(e.target.value).value() + Number(assistancecosts) + Number(travelcosts) + Number(totalfeesSum);
                                let vat = Number(vatRateField) * Number(netTotal) / 100
                                let gross = Number(netTotal) + Number(vat)
                                this.setState({ administrationcost: e.target.value !== "" ? numeral(e.target.value).value() : '', totalnet: netTotal.toFixed(2), vatField: vat.toFixed(2), totalgross: gross.toFixed(2) })
                              }}
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Summe netto</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              value={Number(totalnet)}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              disabled
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right" >
                            <div className="inline-flex MwSt">
                              <span>MwSt.</span>
                              <NumberFormat
                                customInput={TextField}
                                className="rightToLeft"
                                inputProps={{
                                  maxLength: 40
                                }}
                                variant="outlined"
                                helperText={!isEmpty(error.vatrate) ? error.vatrate : ''} error={!isEmpty(error.vatrate) ? true : false}
                                value={vatRateField !== "" ? Number(vatRateField) : ''}
                                thousandSeparator='.'
                                decimalSeparator=","
                                fixedDecimalScale={true}
                                decimalScale='2'
                                onChange={(e) => {
                                  if (!isEmpty(error.vatrate))
                                    error.vatrate = []
                                  let vat = numeral(e.target.value).value() * Number(totalnet) / 100
                                  let gross = Number(totalnet) + Number(vat)
                                  this.setState({ vatRateField: e.target.value !== "" ? numeral(e.target.value).value() : '', vatField: vat.toFixed(2), totalgross: gross.toFixed(2) })
                                }}
                              />
                              <span>%</span>
                            </div>
                          </TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              value={Number(vatField)}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              disabled
                            />
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan='3' align="right"><span>Rechnungssumme</span></TableCell>
                          <TableCell align="center">
                            <NumberFormat
                              customInput={TextField}
                              className="rightToLeft"
                              inputProps={{
                                maxLength: 40
                              }}
                              variant="outlined"
                              value={Number(totalgross)}
                              thousandSeparator='.'
                              decimalSeparator=","
                              fixedDecimalScale={true}
                              decimalScale='2'
                              disabled
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {!editMode ?
                <Button size="small" variant="outlined" color="primary" onClick={this.createInvoice}>
                  Hinzufügen
              </Button>
                :
                <Button size="small" variant="outlined" color="primary" onClick={this.editInvoice}>
                  Speichern
              </Button>
              }
              <Button onClick={() => this.setState({ processInvoiceDialog: false })} size="small" variant="outlined" color="secondary">
                Abbrechen
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={printActivityDialog}
            className="drucken modal-new-in"
          >
            <DialogTitle>Tätigkeitsnachweis drucken</DialogTitle>
            <DialogContent>
              <DialogContentText >
                <Grid container spacing={1}>
                  <Grid item xs={12} style={{ paddingTop: '30px' }}>
                    <Grid container spacing={1}>
                      <Grid item xs={4} style={{ paddingTop: '10px', fontSize: '14px' }}>Monat</Grid>
                      <Grid item xs={4}>
                        <DatePicker
                          value={monthField === "" ? '' : moment(monthField, monthFormat)}
                          format={monthFormat}
                          bordered={false}
                          disabled={(dateFrom || dateTo) !== "" ? true : false}
                          onChange={(e) => {
                            if (e !== null)
                              this.setState({ monthField: moment(e).format("MM") })
                            else
                              this.setState({ monthField: "" })
                          }}
                          picker="month" />
                      </Grid>
                      <Grid item xs={4}>
                        <DatePicker
                          value={yearField === "" ? '' : moment(yearField, yearFormat)}
                          format={yearFormat}
                          disabled={(dateFrom || dateTo) !== "" ? true : false}
                          bordered={false}
                          onChange={(e) => {
                            if (e !== null)
                              this.setState({ yearField: moment(e).format("YYYY") })
                            else
                              this.setState({ yearField: "" })
                          }}
                          picker="year" />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={4} style={{ paddingTop: '10px', fontSize: '14px' }}>Datum von</Grid>
                      <Grid item xs={3}>
                        <DatePicker
                          value={dateFrom === "" ? '' : moment(dateFrom, dateFormat)}
                          format={dateFormat}
                          bordered={false}
                          placeholder="DD.MM.YYYY"
                          disabled={(monthField || yearField) !== "" ? true : false}
                          onChange={(e) => {
                            if (e !== null)
                              this.setState({ dateFrom: moment(e).format("DD.MM.YYYY") })
                            else
                              this.setState({ dateFrom: "" })
                          }}
                        />
                      </Grid>
                      <Grid item xs={2} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>bis</Grid>
                      <Grid item xs={3}>

                        <DatePicker
                          value={dateTo === "" ? '' : moment(dateTo, dateFormat)}
                          format={dateFormat}
                          bordered={false}
                          disabled={(monthField || yearField) !== "" ? true : false}
                          placeholder="DD.MM.YYYY"
                          onChange={(e) => {
                            if (e !== null)
                              this.setState({ dateTo: moment(e).format("DD.MM.YYYY") })
                            else
                              this.setState({ dateTo: "" })
                          }}
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                      <Grid item xs={4} style={{ paddingTop: '10px', fontSize: '14px' }}>Format</Grid>
                      <Grid item xs={8}>
                        <TextField
                          value={selectedFormat}
                          select
                          variant="outlined"
                          className="select-box"
                          size="small"
                          fullWidth
                          onChange={(e) => this.setState({ selectedFormat: e.target.value })}
                        >
                          <MenuItem value={'Excel'}>Excel</MenuItem>
                          <MenuItem value={'PDF'}>PDF</MenuItem>
                        </TextField>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContentText>
              <div style={{ marginTop: "20px", textAlign: "center" }}>
                {exportData &&
                  selectedFormat === "PDF" &&
                  <Pdf targetRef={ref} filename="invoices-record.pdf" options={options}>
                    {({ toPdf }) => (<Button onClick={toPdf} size="small" variant="outlined" color="primary" >
                      Download PDF
                    </Button>)}
                  </Pdf>
                }
                {exportData &&
                  selectedFormat === "Excel" &&
                  <ReactHTMLTableToExcel
                    className="MuiButtonBase-root MuiButton-root MuiButton-outlined MuiButton-outlinedPrimary MuiButton-outlinedSizeSmall MuiButton-sizeSmall"
                    table="invoice_table"
                    filename={'Invoices-' + Date.now()}
                    sheet="tablexls"
                    buttonText={'Download Excel file'} />
                }
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.filteredInvoice} size="small" variant="outlined" color="primary" >
                Speichern
                  </Button>
              <Button onClick={() => {
                if (exportData === true) {
                  this.props.GetInvoices(propsProjectData.id)
                }
                this.setState({ printActivityDialog: false, exportData: false, selectedFormat: '', monthField: '', yearField: '', dateTo: '', dateFrom: '' })
              }} size="small" variant="outlined" color="secondary">
                Abbrechen
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={deleteDialog}
          >
            <DialogTitle>Rechnung löschen</DialogTitle>
            <DialogContent>
              <DialogContentText >
                Sind Sie sicher?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={this.deleteInvoice} size="small" variant="outlined" color="primary" >
                Bestätigen
              </Button>
              <Button onClick={() => this.setState({ deleteDialog: false })} size="small" variant="outlined" color="secondary">
                Abbrechen
              </Button>
            </DialogActions>
          </Dialog>
        </div >
      </div >
    )
  }
}

const mapStateToProps = ({ projectsData, systems }) => {
  return {
    project_invoices: projectsData.project_invoices,
    filtered_invoices: projectsData.filtered_invoices,
    project_invoices_summary: projectsData.project_invoices_summary,
    build_invoice: projectsData.build_invoice,
    system_settings: systems.system_settings,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    GetInvoices: (id) => dispatch(GetInvoices(id)),
    BuildInvoice: (projectID) => dispatch(BuildInvoice(projectID)),
    CreateNewInvoice: (data) => dispatch(CreateNewInvoice(data)),
    EditInvoice: (data) => dispatch(EditInvoice(data)),
    FilterInvoices: (data) => dispatch(FilterInvoices(data)),
    DeleteInvoice: (id, invoiceId) => dispatch(DeleteInvoice(id, invoiceId)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Invoices)
